<div class="card mb-4 box-shadow cursor-pointer border-0" (click)="navigate()">
  <div class="img-hover-zoom">
    <img class="card-img-top" [src]="cardImgSrc">
  </div>
  <div class="card-body">
    <h2 class="card-text">{{ header }}</h2>
    <p class="card-text">{{ subHeader }}</p>
  </div>
</div>